import i18n from "../../../../../../../constants/i18n";
import Et3Image from "../../../../../../../core/et3-Image";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const PendingResolve = withLiteObserverAndTheme<{
  dataStatusIsPending: boolean;
  acceptDataCallback: () => Promise<void>;
  rejectDataCallback: () => Promise<void>;
}>((props) => {
  const { theme, dataStatusIsPending, acceptDataCallback, rejectDataCallback } =
    props;
  const { colors } = theme;

  return dataStatusIsPending ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={150}
      height={55}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER")}
        imageName={"accepted-logo"}
        size={39}
        onClick={async () => await acceptDataCallback()}
        style={{ cursor: "pointer" }}
      />
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER")}
        imageName={"rejected-logo"}
        size={39}
        onClick={async () => await rejectDataCallback()}
        style={{ cursor: "pointer" }}
      />
    </ET3Div>
  ) : null;
});

export default PendingResolve;
